import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f9003c06"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "resume_contents_wrapper" }
const _hoisted_2 = { class: "resume_layout_item" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "resume_title" }, "学歴", -1))
const _hoisted_4 = { class: "resume_item" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "resume_item_title" }, "卒業区分", -1))
const _hoisted_6 = { class: "resume_item_value" }
const _hoisted_7 = { class: "resume_item_value_text" }
const _hoisted_8 = { class: "profile_education_badge" }
const _hoisted_9 = { class: "profile_education_school_name" }
const _hoisted_10 = { class: "profile_education_school_department" }
const _hoisted_11 = { class: "profile_education_item" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "profile_education_item_title" }, "入学年月", -1))
const _hoisted_13 = { class: "profile_education_item_value" }
const _hoisted_14 = { class: "profile_education_item" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "profile_education_item_title" }, "卒業年月", -1))
const _hoisted_16 = { class: "profile_education_item_value" }
const _hoisted_17 = { class: "resume_button" }
const _hoisted_18 = { class: "resume_button_inner" }
const _hoisted_19 = { class: "resume_layout_item" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "resume_title" }, "資格", -1))
const _hoisted_21 = { class: "resume_item" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "resume_item_title" }, "運転免許証", -1))
const _hoisted_23 = { class: "resume_item_value" }
const _hoisted_24 = {
  key: 0,
  class: "resume_item_value_text"
}
const _hoisted_25 = {
  key: 1,
  class: "resume_item_value_text"
}
const _hoisted_26 = { class: "resume_item" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "resume_item_title" }, "資格", -1))
const _hoisted_28 = { class: "resume_item_value" }
const _hoisted_29 = { class: "resume_item_value_text" }
const _hoisted_30 = { class: "resume_button" }
const _hoisted_31 = { class: "resume_button_inner" }
const _hoisted_32 = { class: "resume_layout_item" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "resume_title" }, "言語", -1))
const _hoisted_34 = { class: "resume_item" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "resume_item_title" }, "英語力", -1))
const _hoisted_36 = { class: "resume_item_value" }
const _hoisted_37 = { class: "resume_item_value_text" }
const _hoisted_38 = { class: "resume_item" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "resume_item_title" }, "その他言語", -1))
const _hoisted_40 = { class: "resume_item_value" }
const _hoisted_41 = { class: "resume_button" }
const _hoisted_42 = { class: "resume_button_inner" }
const _hoisted_43 = { class: "resume_layout_item" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "resume_title" }, "PCソフト", -1))
const _hoisted_45 = { class: "resume_item" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "resume_item_title" }, "OS", -1))
const _hoisted_47 = { class: "resume_item_value" }
const _hoisted_48 = { class: "resume_item" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "resume_item_title" }, "ソフト", -1))
const _hoisted_50 = { class: "resume_item_value" }
const _hoisted_51 = { class: "resume_button" }
const _hoisted_52 = { class: "resume_button_inner" }
const _hoisted_53 = { class: "resume_layout_item" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "resume_title" }, "プログラミング言語", -1))
const _hoisted_55 = { class: "resume_item" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "resume_item_title" }, "プログラミング言語", -1))
const _hoisted_57 = { class: "resume_item_value" }
const _hoisted_58 = { class: "resume_button" }
const _hoisted_59 = { class: "resume_button_inner" }
const _hoisted_60 = { class: "resume_layout_item" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "resume_title" }, "携わったことのあるクライアント業種", -1))
const _hoisted_62 = { class: "resume_item" }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "resume_item_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "resume_item_title_clause" }, "携わったことのある"),
  /*#__PURE__*/_createElementVNode("span", { class: "resume_item_title_clause" }, "クライアント業種")
], -1))
const _hoisted_64 = { class: "resume_item_value" }
const _hoisted_65 = { class: "resume_button is-border-bottom-none" }
const _hoisted_66 = { class: "resume_button_inner" }

import TabBar from '@/components/TabBar.vue';
import { QualificationInfo, LangSkill, UsableSoftware, UsableLanguage, Qualification } from '@/api/careersheetEndpoint';
import { SchoolHistoryInfoItem } from '@/types';
import { MasterDataLangSkl, MasterDataOtrLang } from '@/api/masterDataEndpoint';
import BaseButton from '@/components/BaseButton.vue';
import { Ref, ref, PropType, toRefs, computed } from 'vue';
import store from '@/store';
import { useRouter, useRoute } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'EducationSkill',
  props: {
  isLink: {
    type: Boolean,
    default: false,
  },
  qualificationRes: {
    type: Object as PropType<QualificationInfo>,
    required: true,
  },
  langSkillRes: {
    type: Object as PropType<LangSkill>,
    required: true,
  },
  mstLangSklRes: {
    type: Array as PropType<MasterDataLangSkl[]>,
    required: true,
  },
  mstOtrLangRes: {
    type: Array as PropType<MasterDataOtrLang[]>,
    required: true,
  },
  usableSoftRes: {
    type: Object as PropType<UsableSoftware>,
    required: true,
  },
  usableLangRes: {
    type: Object as PropType<UsableLanguage>,
    required: true,
  },
},
  setup(__props) {

const props = __props

const route = useRoute();
const router = useRouter();


const { qualificationRes, langSkillRes, mstLangSklRes, mstOtrLangRes, usableSoftRes, usableLangRes } = toRefs(props);

// 学歴
const lstschlId: Ref<number> = computed(() => store.getters['careerSheetEducation/lstschlId']);
const scienceFlg: Ref<boolean> = computed(() => store.getters['careerSheetEducation/scienceFlg']);
const schoolHistoryInfoList: Ref<SchoolHistoryInfoItem[]> = computed(() => store.getters['careerSheetEducation/schoolHistoryInfoList']);
const mstListLstSchlObject = computed(() => store.getters['master/mstListLstSchlObject']);
const mstListEntranceObject = computed(() => store.getters['master/mstListEntranceObject']);
const mstListGradObject = computed(() => store.getters['master/mstListGradObject']);
const graduationCategory = computed(() => {
  if (!lstschlId.value) return '';
  const sience = scienceFlg.value ? ' 理系' : '';
  return mstListLstSchlObject.value[lstschlId.value] + sience;
});

// 資格
const drLicenseFlg = ref(false);
const qualificationList: Ref<Qualification[]> = ref([]);
// 言語
const engskl = ref('');
const otrlangSkillArray: Ref<string[]> = ref([]);
// PCソフト
const usableOsArray: Ref<string[]> = ref([]);
const usableSoftArray: Ref<string[]> = ref([]);
// プログラミング言語
const usableLangArray: Ref<string[]> = ref([]);

// 取得処理
const init = async () => {
  try {
    // 資格
    drLicenseFlg.value = qualificationRes.value.drLicenseFlg;
    // 取得年を昇順にソート
    qualificationList.value = qualificationRes.value.qualificationList.sort((a, b) => a.qualyr - b.qualyr);

    // 言語
    engskl.value = mstLangSklRes.value.filter((i) => i.code === langSkillRes.value.engsklId)[0]?.name || '';
    const otrlang1 = mstOtrLangRes.value.filter((i) => i.code === langSkillRes.value.otrlang1Id)[0]?.name || '';
    const otrlang2 = mstOtrLangRes.value.filter((i) => i.code === langSkillRes.value.otrlang2Id)[0]?.name || '';
    const otrlang3 = mstOtrLangRes.value.filter((i) => i.code === langSkillRes.value.otrlang3Id)[0]?.name || '';
    otrlangSkillArray.value = [otrlang1, otrlang2, otrlang3];

    // PCソフト(OS)
    if (usableSoftRes.value.osWindowsFlg) {
      usableOsArray.value.push('Windows');
    }
    if (usableSoftRes.value.osMacFlg) {
      usableOsArray.value.push('Mac');
    }
    if (usableSoftRes.value.osUnixFlg) {
      usableOsArray.value.push('Unix');
    }
    // PCソフト(ソフト)
    if (usableSoftRes.value.msWordFlg) {
      usableSoftArray.value.push('Microsoft Word');
    }
    if (usableSoftRes.value.msExcelFlg) {
      usableSoftArray.value.push('Microsoft Excel');
    }
    if (usableSoftRes.value.msPowerpointFlg) {
      usableSoftArray.value.push('Microsoft Powerpoint');
    }
    if (usableSoftRes.value.msAccessFlg) {
      usableSoftArray.value.push('Microsoft Access');
    }
    if (usableSoftRes.value.photoshopFlg) {
      usableSoftArray.value.push('Photoshop');
    }
    if (usableSoftRes.value.illustratorFlg) {
      usableSoftArray.value.push('Illustrator');
    }
    if (usableSoftRes.value.inDesignFlg) {
      usableSoftArray.value.push('InDesign');
    }
    if (usableSoftRes.value.dreamweaverFlg) {
      usableSoftArray.value.push('Dreamweaver');
    }
    if (usableSoftRes.value.adobeXDFlg) {
      usableSoftArray.value.push('AdobeXD');
    }
    if (usableSoftRes.value.sketchFlg) {
      usableSoftArray.value.push('Sketch');
    }
    if (usableSoftRes.value.figmaFlg) {
      usableSoftArray.value.push('Figma');
    }
    if (usableSoftRes.value.afterEffectsFlg) {
      usableSoftArray.value.push('AfterEffects');
    }
    if (usableSoftRes.value.lightroomFlg) {
      usableSoftArray.value.push('Lightroom');
    }
    if (usableSoftRes.value.premiereFlg) {
      usableSoftArray.value.push('Premiere');
    }
    if (usableSoftRes.value.finalCutProFlg) {
      usableSoftArray.value.push('FinalCutPro');
    }
    if (usableSoftRes.value.ediusFlg) {
      usableSoftArray.value.push('EDIUS');
    }
    if (usableSoftRes.value.unityFlg) {
      usableSoftArray.value.push('Unity');
    }
    if (usableSoftRes.value.threeDCgFlg) {
      usableSoftArray.value.push('3DCG（3ds Max、Maya、STRATAなど）');
    }
    if (usableSoftRes.value.cadFlg) {
      usableSoftArray.value.push('CAD（shade、Vectorworksなど）');
    }
    if (usableSoftRes.value.googleAnalyticsFlg) {
      usableSoftArray.value.push('Google Analytics');
    }
    if (usableSoftRes.value.googleSearchConsoleFlg) {
      usableSoftArray.value.push('Google Search Console');
    }
    if (usableSoftRes.value.biFlg) {
      usableSoftArray.value.push('BIツール（Tableau、QlikViewなど）');
    }
    if (usableSoftRes.value.statisticalAnalysisFlg) {
      usableSoftArray.value.push('統計解析ツール（SPSS、SAS、JMPなど）');
    }
    if (usableSoftRes.value.sfaFlg) {
      usableSoftArray.value.push('SFAツール（Salesforceなど）');
    }
    if (usableSoftRes.value.maFlg) {
      usableSoftArray.value.push('MAツール（Pardot、Marketoなど）');
    }
    if (usableSoftRes.value.cloudPlatFormFlg) {
      usableSoftArray.value.push('クラウドプラットフォーム（AWS、GCP、Azureなど）');
    }

    // プログラミング言語
    if (usableLangRes.value.langCFlg) {
      usableLangArray.value.push('C');
    }
    if (usableLangRes.value.cplusplusFlg) {
      usableLangArray.value.push('C++');
    }
    if (usableLangRes.value.csharpFlg) {
      usableLangArray.value.push('C#');
    }
    if (usableLangRes.value.javaFlg) {
      usableLangArray.value.push('Java');
    }
    if (usableLangRes.value.phpFlg) {
      usableLangArray.value.push('PHP');
    }
    if (usableLangRes.value.sqlFlg) {
      usableLangArray.value.push('SQL');
    }
    if (usableLangRes.value.aspFlg) {
      usableLangArray.value.push('ASP');
    }
    if (usableLangRes.value.javascriptFlg) {
      usableLangArray.value.push('Javascript');
    }
    if (usableLangRes.value.htmlFlg) {
      usableLangArray.value.push('HTML');
    }
    if (usableLangRes.value.xmlFlg) {
      usableLangArray.value.push('XML');
    }
    if (usableLangRes.value.xhtmlFlg) {
      usableLangArray.value.push('XHTML');
    }
    if (usableLangRes.value.cssFlg) {
      usableLangArray.value.push('CSS');
    }
    if (usableLangRes.value.sassFlg) {
      usableLangArray.value.push('Sass');
    }
    if (usableLangRes.value.ftpFlg) {
      usableLangArray.value.push('ftp');
    }
    if (usableLangRes.value.wordPressFlg) {
      usableLangArray.value.push('WordPress実装');
    }
    if (usableLangRes.value.movableTypeFlg) {
      usableLangArray.value.push('Movable Type実装');
    }
    if (usableLangRes.value.langRFlg) {
      usableLangArray.value.push('R');
    }
    if (usableLangRes.value.perlFlg) {
      usableLangArray.value.push('Perl');
    }
    if (usableLangRes.value.rubyFlg) {
      usableLangArray.value.push('Ruby');
    }
    if (usableLangRes.value.goFlg) {
      usableLangArray.value.push('Go');
    }
    if (usableLangRes.value.pythonFlg) {
      usableLangArray.value.push('Python');
    }
    if (usableLangRes.value.swiftFlg) {
      usableLangArray.value.push('Swift');
    }
    if (usableLangRes.value.kotlinFlg) {
      usableLangArray.value.push('Kotlin');
    }
  } catch (e) {
    console.error(e);
  }
};
init();

// 携わったことのあるクライアント業種
const businesstypeLabelList: string[] = store.getters['careerSheetBusinesstype/businesstypeLabelList'];

// 学歴編集画面
const transitionEditEducationPage = () => {
  if (route.query.ref === 'e') {
    router.push({ name: 'e51', query: { ref: 'e' } });
  } else {
    router.push({ name: 'e51' });
  }
};
// 資格_編集
const transitionEditSkillLicensePage = () => {
  if (route.query.ref === 'e') {
    router.push({ name: 'e53', query: { ref: 'e' } });
  } else {
    router.push({ name: 'e53' });
  }
};
// 言語_編集
const transitionEditSkillLanguagePage = () => {
  if (route.query.ref === 'e') {
    router.push({ name: 'e55', query: { ref: 'e' } });
  } else {
    router.push({ name: 'e55' });
  }
};
// PCソフト_編集
const transitionEditSkillSoftwarePage = () => {
  if (route.query.ref === 'e') {
    router.push({ name: 'e57', query: { ref: 'e' } });
  } else {
    router.push({ name: 'e57' });
  }
};
// プログラミング言語(PC)_編集
const transitionEditSkillPclanguagePage = () => {
  if (route.query.ref === 'e') {
    router.push({ name: 'e59', query: { ref: 'e' } });
  } else {
    router.push({ name: 'e59' });
  }
};
// 携わったことのあるクライアント業種_編集
const transitionEditSkillBusinesstype = () => {
  if (route.query.ref === 'e') {
    router.push({ name: 'e61', query: { ref: 'e' } });
  } else {
    router.push({ name: 'e61' });
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(TabBar, { isLink: __props.isLink }, null, 8, ["isLink"]),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("p", _hoisted_7, _toDisplayString(_unref(graduationCategory)), 1)
        ])
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(schoolHistoryInfoList), (schoolHistory, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "profile_education",
          key: index
        }, [
          _createElementVNode("div", _hoisted_8, "学歴 " + _toDisplayString(index + 1), 1),
          _createElementVNode("div", _hoisted_9, _toDisplayString(schoolHistory.schlname), 1),
          _createElementVNode("div", _hoisted_10, _toDisplayString(schoolHistory.schldeptname), 1),
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createElementVNode("div", _hoisted_13, _toDisplayString(schoolHistory.entranceyr) + "年" + _toDisplayString(schoolHistory.entrancemon) + "月 " + _toDisplayString(schoolHistory.entranceFlg !== null ? _unref(mstListEntranceObject)[schoolHistory.entranceFlg] : ''), 1)
          ]),
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            _createElementVNode("div", _hoisted_16, _toDisplayString(schoolHistory.gradyr) + "年" + _toDisplayString(schoolHistory.gradmon) + "月 " + _toDisplayString(schoolHistory.gradFlg !== null ? _unref(mstListGradObject)[schoolHistory.gradFlg] : ''), 1)
          ])
        ]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createElementVNode("div", _hoisted_18, [
        _createVNode(BaseButton, {
          theme: "secondary",
          onClick: transitionEditEducationPage
        }, {
          default: _withCtx(() => [
            _createTextVNode("学歴を変更する")
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_19, [
      _hoisted_20,
      _createElementVNode("div", _hoisted_21, [
        _hoisted_22,
        _createElementVNode("div", _hoisted_23, [
          (drLicenseFlg.value)
            ? (_openBlock(), _createElementBlock("p", _hoisted_24, "あり"))
            : (_openBlock(), _createElementBlock("p", _hoisted_25, "なし"))
        ])
      ]),
      _createElementVNode("div", _hoisted_26, [
        _hoisted_27,
        _createElementVNode("div", _hoisted_28, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(qualificationList.value, (qualification, index) => {
            return (_openBlock(), _createElementBlock("li", { key: index }, [
              _createElementVNode("p", _hoisted_29, _toDisplayString(qualification.qualyr) + "年" + _toDisplayString(qualification.qualmon) + "月 " + _toDisplayString(qualification.qualdetails), 1)
            ]))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_30, [
      _createElementVNode("div", _hoisted_31, [
        _createVNode(BaseButton, {
          theme: "secondary",
          onClick: transitionEditSkillLicensePage
        }, {
          default: _withCtx(() => [
            _createTextVNode("資格を変更する")
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_32, [
      _hoisted_33,
      _createElementVNode("div", _hoisted_34, [
        _hoisted_35,
        _createElementVNode("div", _hoisted_36, [
          _createElementVNode("p", _hoisted_37, _toDisplayString(engskl.value), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_38, [
        _hoisted_39,
        _createElementVNode("div", _hoisted_40, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(otrlangSkillArray.value, (otrlang) => {
            return (_openBlock(), _createElementBlock("p", {
              class: "resume_item_value_text",
              key: otrlang
            }, _toDisplayString(otrlang), 1))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_41, [
      _createElementVNode("div", _hoisted_42, [
        _createVNode(BaseButton, {
          theme: "secondary",
          onClick: transitionEditSkillLanguagePage
        }, {
          default: _withCtx(() => [
            _createTextVNode("言語を変更する")
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_43, [
      _hoisted_44,
      _createElementVNode("div", _hoisted_45, [
        _hoisted_46,
        _createElementVNode("div", _hoisted_47, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(usableOsArray.value, (usableOs) => {
            return (_openBlock(), _createElementBlock("p", {
              class: "resume_item_value_text",
              key: usableOs
            }, _toDisplayString(usableOs), 1))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_48, [
        _hoisted_49,
        _createElementVNode("div", _hoisted_50, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(usableSoftArray.value, (usableSoft) => {
            return (_openBlock(), _createElementBlock("p", {
              class: "resume_item_value_text",
              key: usableSoft
            }, _toDisplayString(usableSoft), 1))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_51, [
      _createElementVNode("div", _hoisted_52, [
        _createVNode(BaseButton, {
          theme: "secondary",
          onClick: transitionEditSkillSoftwarePage
        }, {
          default: _withCtx(() => [
            _createTextVNode("PCソフトを変更する")
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_53, [
      _hoisted_54,
      _createElementVNode("div", _hoisted_55, [
        _hoisted_56,
        _createElementVNode("div", _hoisted_57, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(usableLangArray.value, (usableLang) => {
            return (_openBlock(), _createElementBlock("p", {
              class: "resume_item_value_text",
              key: usableLang
            }, _toDisplayString(usableLang), 1))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_58, [
      _createElementVNode("div", _hoisted_59, [
        _createVNode(BaseButton, {
          theme: "secondary",
          onClick: transitionEditSkillPclanguagePage
        }, {
          default: _withCtx(() => [
            _createTextVNode("プログラミング言語を変更する")
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_60, [
      _hoisted_61,
      _createElementVNode("div", _hoisted_62, [
        _hoisted_63,
        _createElementVNode("div", _hoisted_64, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(businesstypeLabelList), (businesstype, index) => {
            return (_openBlock(), _createElementBlock("p", {
              class: "resume_item_value_text",
              key: index
            }, _toDisplayString(businesstype), 1))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_65, [
      _createElementVNode("div", _hoisted_66, [
        _createVNode(BaseButton, {
          theme: "secondary",
          onClick: transitionEditSkillBusinesstype
        }, {
          default: _withCtx(() => [
            _createTextVNode("携わったことのあるクライアント業種を変更する")
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})